import { LineItem } from "chargebee-typescript/lib/resources/invoice";
import { Link as NativeLink } from "react-router-dom";
import styled from "styled-components";

export const SectionTitle = styled("h2")`
  // margin: 0px 0px 0px 0px;
  // font-size: 18px;
  // font-weight: 600;

  margin: 0px;
  font-weight: 400;
  font-size: 22px;
  line-height: 26px;
`;

export const SectionDescription = styled("p")`
  margin: 0px 0px 0px 0px;
  font-size: 14px;
  font-weight: normal;
`;

export const Line = styled('div')`
  height: 2px;
  background-color: rgb(214 214 214 / 50%);
`

export const Statistics = styled("div")`
  overflow: scroll;
  display: flex;
  gap: 16px;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  
  /* Ocultar scrollbar */
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
  scrollbar-width: none;  /* Firefox */
  &::-webkit-scrollbar { 
    display: none;  /* Safari and Chrome */
  }

  @media (min-width: ${(props) => props.theme.mediaBreakpoints.mdMin}) {
    overflow: hidden;
    min-height: 175px;
    display: flex;
    gap: 0;
    align-items: center;
    justify-content: center;
    border-radius: 16px;
    flex-direction: row;
    background-color: #fff;
    box-shadow: 0px 1px 14px rgba(0, 0, 0, 0.07);
  }
`;



export const Statistic = styled("div") <{ isEmpty: boolean }>`
  // position: relative;
  // flex-shrink: 0;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: center;
  // background-color: #fff;
  // padding:  ${(props) => props.isEmpty ? "18px 14px" : "28px 34px"};
  // scroll-snap-align: start;
  // border-radius: 16px;
  // box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 14px;
  // width: 100%;
  // max-width: 185px;


  position: relative;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  background-color: rgb(255, 255, 255);
   padding:  ${(props) => props.isEmpty ? "18px 14px" : "28px 34px"};
  scroll-snap-align: start;
  border-radius: 16px;
  box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 14px;
  width: 100%;
  max-width: 320px;

  @media (min-width: ${(props) => props.theme.mediaBreakpoints.mdMin}) {
    flex-shrink: ${(props) => props.isEmpty ? 1 : 0};
    // width: auto;
    padding: ${(props) => props.isEmpty ? "0px 24px" : "24px"};
    border-radius: 0px;
    box-shadow: none;
  }

  &:not(:last-child) {
    &:after {
      content: "";
      background-color: rgba(196, 196, 196, 1);  
      
      @media (min-width: ${(props) => props.theme.mediaBreakpoints.mdMin}) {
        display: block;
        position: absolute;
        top: 50%;
        right: 0px;
        transform: translateY(-50%);
        width: 1px;
        height: 90px;
      }
    }
  }
`;

export const StatisticHeader = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  @media (max-width: ${(props) => props.theme.mediaBreakpoints.mdMax}) {
    align-items: center;
  }

  & > div {
    display: flex;
    align-items: center;
    justify-content: center;
    // flex-direction: column;

    // @media (max-width: ${(props) => props.theme.mediaBreakpoints.lgMax}) {
    //   flex-direction: row;
    // }
  }
`;

export const Title = styled("h3")`
  margin: 0px;
  font-weight: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 19px;
  color: #626768;
  max-width: 245px;
`;

export const Image = styled("img")`
  display: block;
`;

export const Value = styled("div")`
  font-weight: 500;
  font-size: 35px;
  color: #6C5CE7;
  text-align: center;
  width: 100%;
  font-family: 'Archivo', sans-serif;
`;

export const DotWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
  padding: 0 20px;

  @media (min-width: ${(props) => props.theme.mediaBreakpoints.mdMin}) {
    display: none;
  }
`;

export const Dot = styled.div<{ active?: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ active }) => (active ? '#6C5CE7' : '#dfe6e9')};
  transition: background-color 0.3s ease;
`;

export const SubValue = styled("div")`
  font-weight: 400;
  font-size: 15px;
  text-align: center;
  width: 100%;
`;

export const SubMetric = styled("div")`
  text-align: center;
`;

export const ComparisonBox = styled("div") <{ isGreatherThanPreviousPeriod?: boolean }>`
  margin-bottom: 2px;
  background-color: ${(props) => (props.isGreatherThanPreviousPeriod ? "#d1fab3" : "#fde9ee")};
  box-sizing: border-box;
  color: ${(props) => (props.isGreatherThanPreviousPeriod ? "#217005" : "#c0123c")};
  padding: 1px 6px 1px 6px;
  border: ${(props) => (props.isGreatherThanPreviousPeriod ? "1px solid #a8f170" : "1px solid #fbd3dc")};
  border-radius: 5px;
  font-size: 14px;
  line-height: 14px;
  display: inline-block;
  width: auto;
  text-align: center;
  vertical-align: middle;
`;

export const PreviousPeriod = styled("span")`
  font-size: 14px;
  font-weight: 350;
  color: #596171;
  text-align: center;
`;

export const CurrencyText = styled("span")`
  font-size: 10px;
  color: #596171;
  font-weight: 400;
  text-align: center;
`;

export const EmptyState = styled("div")`
  background-color: #fafafa;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  p {
    font-size: 12px;
    line-height: 14px;
    margin: 0px 0px 4px;
  }
`;

export const Link = styled(NativeLink)`
  font-size: 14px;
  line-height: 17px;
  color: #6c5ce7;
  text-decoration: underline;
`;

export const Button = styled("button")`
  font-size: 14px;
  line-height: 17px;
  color: #6c5ce7;
  text-decoration: underline;
  padding: 0px;
  margin: 0px;
  border: 0px;
  background: none;
  cursor: pointer;
`;